import { useMsal } from '@azure/msal-react';
import { useEffect } from 'react';

const SSOLogin = () => {
  const { instance } = useMsal();

  useEffect(() => {
    const fetchData = async () => {
      await instance.loginRedirect();
    };

    fetchData().catch((e) => {
      console.error(e);
    });
  }, []);

  return <div></div>;
};

export default SSOLogin;
